import React from "react";
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const selectedSearchValues = this.props.selectedSearchValues;
    const cropSupplyDetails = this.props.cropSupplyDetails;
    const monthDays = this.props.monthDays;

    const options = {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    };

    const monthMap = {
      'Jan': 'January',
      'Feb': 'February',
      'Mar': 'March',
      'Apr': 'April',
      'May': 'May',
      'Jun': 'June',
      'Jul': 'July',
      'Aug': 'August',
      'Sep': 'September',
      'Oct': 'October',
      'Nov': 'November',
      'Dec': 'December'
    };

    const formattedDate = selectedSearchValues.startDate.replace(/^(...)/, (match) => monthMap[match]);

    const numDays = monthDays.length;
    const regNoPct = 5;
    const customerPct = 13;
    const totalPct = 6;
    const dayColPct = ((100 - regNoPct - customerPct - totalPct) / numDays).toFixed(2);

    const cell = { border: '1px solid #ccc', fontSize: '11px', padding: '2px 3px' };
    const bold = { ...cell, fontWeight: 'bold' };

    return (
      <div>
        <div>
          <Table
            size="small"
            aria-label="simple table"
            style={{ tableLayout: 'fixed', width: '100%', borderCollapse: 'collapse' }}
          >
            <colgroup>
              <col style={{ width: `${regNoPct}%` }} />
              <col style={{ width: `${customerPct}%` }} />
              {monthDays.map((_, i) => (
                <col key={i} style={{ width: `${dayColPct}%` }} />
              ))}
              <col style={{ width: `${totalPct}%` }} />
            </colgroup>

            <TableHead>
              <TableRow>
                <TableCell style={bold} align="left">Reg.No</TableCell>
                <TableCell style={bold} align="left">Customer</TableCell>
                {monthDays.map((row, index) => (
                  <TableCell key={index} style={{ ...bold, textAlign: 'center' }}>
                    {moment(row).format('DD')}
                  </TableCell>
                ))}
                <TableCell style={bold} align="right">Total</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {cropSupplyDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={cell} align="left">{row.registrationNumber}</TableCell>
                  <TableCell style={cell} align="left">
                    {row.name}
                  </TableCell>
                  {monthDays.map((rows, idx) => {
                    const found = row.groupList.find(x => x.cropCollectedDate == rows);
                    return (
                      <TableCell key={idx} style={{ ...cell, textAlign: 'right' }}>
                        {found == undefined ? '-' : (found.cropWeight === 0 ? '-' : (found.cropWeight).toLocaleString('en-US', options))}
                      </TableCell>
                    );
                  })}
                  <TableCell style={{ ...bold, textAlign: 'right' }}>
                    {(row.totalAmount).toLocaleString('en-US', options)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            <TableRow>
              <TableCell colSpan={2} style={{ ...bold, textAlign: 'left' }}>Total</TableCell>
              {monthDays.map((day, index) => {
                const dayTotal = cropSupplyDetails.reduce((total, row) => {
                  const found = row.groupList.find(x => x.cropCollectedDate === day);
                  return total + (found ? parseFloat(found.cropWeight) : 0);
                }, 0).toLocaleString('en-US', options);
                return (
                  <TableCell key={index} style={{ ...bold, textAlign: 'right' }}>
                    {dayTotal !== '0' ? dayTotal : '-'}
                  </TableCell>
                );
              })}
              <TableCell style={{ ...bold, textAlign: 'right' }}>
                {cropSupplyDetails.reduce((total, row) => total + parseFloat(row.totalAmount), 0).toLocaleString('en-US', options)}
              </TableCell>
            </TableRow>
          </Table>
        </div>
        <div>&nbsp;</div>
      </div>
    );
  }
}
